var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Modal",
        { attrs: { modalId: "manage-plan-modal", size: "modal-md" } },
        [
          _c(
            "ModalHeader",
            {
              attrs: {
                title: _vm.$t("xManagePlan"),
                icon: "far fa-circle-dollar colorOrange mr-1"
              }
            },
            [
              _c("div", { staticClass: "cols-auto" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-icon-button btn-icon-button--gray",
                    attrs: {
                      type: "button",
                      "data-test-hook": "close-manage-plan-modal"
                    },
                    on: {
                      click: function($event) {
                        return _vm.closeManagePlanModal()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-times" })]
                )
              ])
            ]
          ),
          _c("ModalBody", [
            _c(
              "div",
              { staticClass: "custom-control custom-radio mt-2 mb-3" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.managePlanType,
                      expression: "managePlanType"
                    }
                  ],
                  staticClass: "custom-control-input",
                  attrs: {
                    type: "radio",
                    disabled: _vm.shouldDisableCadenceChange,
                    id: "changePaymentCadence",
                    value: "changePaymentCadence",
                    "data-test-hook": "radio-change-payment-cadence"
                  },
                  domProps: {
                    checked: _vm._q(_vm.managePlanType, "changePaymentCadence")
                  },
                  on: {
                    change: function($event) {
                      _vm.managePlanType = "changePaymentCadence"
                    }
                  }
                }),
                _c(
                  "label",
                  {
                    staticClass: "custom-control-label",
                    attrs: { for: "changePaymentCadence" }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("xChangePaymentCadence")) + " ")]
                ),
                !_vm.shouldDisableCadenceChange
                  ? _c(
                      "p",
                      { staticClass: "text-small radio-button-subtext" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("xChangePaymentCadenceSubtext")) +
                            " "
                        )
                      ]
                    )
                  : _c(
                      "p",
                      { staticClass: "text-small radio-button-subtext" },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("xCadenceChangeDisabled")) + " "
                        )
                      ]
                    )
              ]
            ),
            _vm.shouldShowRemoveAndDowngradeOptions()
              ? _c("div", { staticClass: "custom-control custom-radio mb-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.managePlanType,
                        expression: "managePlanType"
                      }
                    ],
                    staticClass: "custom-control-input",
                    attrs: {
                      type: "radio",
                      id: "removeProducts",
                      value: "removeProducts",
                      "data-test-hook": "radio-remove-products"
                    },
                    domProps: {
                      checked: _vm._q(_vm.managePlanType, "removeProducts")
                    },
                    on: {
                      change: function($event) {
                        _vm.managePlanType = "removeProducts"
                      }
                    }
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label",
                      attrs: { for: "removeProducts" }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("xRemoveProducts")) + " ")]
                  ),
                  _c("p", { staticClass: "text-small radio-button-subtext" }, [
                    _vm._v(" " + _vm._s(_vm.$t("xRemoveProductsSubtext")) + " ")
                  ])
                ])
              : _vm._e(),
            _vm.shouldShowRemoveAndDowngradeOptions()
              ? _c("div", { staticClass: "custom-control custom-radio mb-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.managePlanType,
                        expression: "managePlanType"
                      }
                    ],
                    staticClass: "custom-control-input",
                    attrs: {
                      type: "radio",
                      id: "downgradePlan",
                      value: "downgradePlan",
                      "data-test-hook": "radio-downgrade-plan"
                    },
                    domProps: {
                      checked: _vm._q(_vm.managePlanType, "downgradePlan")
                    },
                    on: {
                      change: function($event) {
                        _vm.managePlanType = "downgradePlan"
                      }
                    }
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label",
                      attrs: { for: "downgradePlan" }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("xDowngradePlan")) + " ")]
                  ),
                  _c("p", { staticClass: "text-small radio-button-subtext" }, [
                    _vm._v(" " + _vm._s(_vm.$t("xDowngradePlanSubtext")) + " ")
                  ])
                ])
              : _vm._e(),
            _c("div", { staticClass: "custom-control custom-radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.managePlanType,
                    expression: "managePlanType"
                  }
                ],
                staticClass: "custom-control-input",
                attrs: {
                  type: "radio",
                  id: "cancelPlan",
                  value: "cancelPlan",
                  "data-test-hook": "radio-cancel-plan"
                },
                domProps: { checked: _vm._q(_vm.managePlanType, "cancelPlan") },
                on: {
                  change: function($event) {
                    _vm.managePlanType = "cancelPlan"
                  }
                }
              }),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "cancelPlan" }
                },
                [_vm._v(" " + _vm._s(_vm.$t("xCancelPlanLowercase")) + " ")]
              ),
              _c("p", { staticClass: "text-small radio-button-subtext" }, [
                _vm._v(" " + _vm._s(_vm.$t("xCancelPlanSubtext")) + " ")
              ])
            ])
          ]),
          _c("ModalFooter", [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-warning flex flex-grow-1",
                attrs: { "data-test-hook": "cancel-button-manage-plan-modal" },
                on: {
                  click: function($event) {
                    return _vm.closeManagePlanModal()
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("xCancel")) + " ")]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-warning flex flex-grow-1",
                attrs: {
                  disabled: !_vm.managePlanType,
                  "data-test-hook": "next-button-manage-plan-modal"
                },
                on: {
                  click: function($event) {
                    return _vm.goToSelectedOption()
                  }
                }
              },
              [
                _vm._v(" " + _vm._s(_vm.$t("xNext")) + " "),
                _c("span", { staticClass: "pl-1" }, [
                  _c("i", { staticClass: "far fa-arrow-right" })
                ])
              ]
            )
          ])
        ],
        1
      ),
      _c("PaymentCadenceModal", {
        attrs: {
          endDate: _vm.subscription.subscriptionRenewalDate,
          subscriptionStore:
            _vm.subscription.subscriptionStore !== undefined
              ? _vm.subscription.subscriptionStore
              : null
        }
      }),
      _c("RemoveProductsSelectionModal", {
        attrs: {
          subscription: _vm.subscription,
          "account-profile": _vm.accountProfile
        }
      }),
      _c("CancelSubscriptionModal", {
        attrs: {
          isCancelLegacy: false,
          endDate: _vm.subscription.subscriptionRenewalDate,
          cancelLegacyApparatusId: null,
          cancelLegacyApparatusType: null,
          cancelSubscriptionApparatuses:
            _vm.subscription.apparatuses !== null
              ? _vm.subscription.apparatuses
              : [],
          cancelSubscriptionProductId:
            _vm.subscription.subscriptionProductId !== undefined
              ? _vm.subscription.subscriptionProductId
              : null,
          cancelSubscriptionStore:
            _vm.subscription.subscriptionStore !== undefined
              ? _vm.subscription.subscriptionStore
              : null
        }
      }),
      _c("DowngradeSubscriptionModal", {
        attrs: {
          currentSubscription: _vm.subscription,
          newSubscription: _vm.newSubscription
        },
        on: { openPayment: _vm.proceedToPaymentForDowngrade }
      }),
      _c("DowngradeUnavailableModal", {
        attrs: {
          "account-profile": _vm.accountProfile,
          "subscription-products": _vm.allSubscriptionProducts
        },
        on: { mustRemoveBeforeDowngrading: _vm.mustRemoveBeforeDowngrading }
      }),
      _c("PaymentModal", {
        attrs: {
          "modal-id": "new-subscription-payment",
          "selected-product": _vm.newSubscription,
          "account-profile": _vm.accountProfile
        },
        on: {
          submit: _vm.subscribeProduct,
          goBack: _vm.returnToDowngrade,
          savePremiumFeaturesGettingReadyInfo:
            _vm.handleDowngradeSubscriptionChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }